// extracted by mini-css-extract-plugin
export default {"issueDependenciesList":"DependencyEvent-module__issueDependenciesList__gDg5JZ2","issueDependencyItem":"DependencyEvent-module__issueDependencyItem__mGr2LSA"};